import { Box } from "@mui/material";
import Header from "../../components/Header";
import { AccesosContent } from "../../components/Accesos/indesx.jsx";

const AccesoPage = () => (
  <Box m="20px">
    <Header title="Acceso" subtitle="Apertura de puertas de acceso" />
    <Box sx={{ maxWidth: 420, mx: "auto", mt: 2 }}>
      <AccesosContent />
    </Box>
  </Box>
);

export default AccesoPage;
